import React from "react";
import { Props } from "./types";

function DeleteTableIcon({ className }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="16"
      height="16"
    >
      <path d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5z" />
      <line x1="8" y1="8" x2="16" y2="16" strokeWidth="2.5" />
      <line x1="16" y1="8" x2="8" y2="16" strokeWidth="2.5" />
    </svg>
  );
}

export { DeleteTableIcon };
